module.exports = __webpack_public_path__ + "static/img/partner-logo-6.b5092a94.png";